import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/downloads/DownloadUsabilityChecklist'

const Download: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'ユーザビリティ UIUX'}
        image={'https://www.i3design.jp/ogp_logo.png'}
        url={'https://www.i3design.jp/download/usabilitychecklist/'}
        title="ユーザビリティチェックリスト | 資料ダウンロード | i3DESIGN アイスリーデザイン"
        description="様々な業種・業界のクライアント様のデザインリニューアルやサービスの新規立ち上げなどを経て得たナレッジの中でも「これだけは絶対に知っていて欲しい！」というものを、基本の50個をピックアップして、チェックリストを作成しています。"
      />
      <Template />
    </>
  )
}

export default Download
